import { Component } from '@angular/core';

@Component({
  selector: 'app-dados-home',
  templateUrl: './dados-home.component.html',
  styleUrls: ['./dados-home.component.scss'],
})
export class DadosHomeComponent {
  abaSelecionada: number = 0;
  menu = [
    { title: 'Receitas Categorias', icon: 'clipboard-text' },
    { title: 'Profissões e Especialidades', icon: 'tool' },
    { title: 'Despesas', icon: 'discount' },
    //{ title: 'Pastas', icon: 'dual-screen' },
    //{ title: 'Entrega de serviços', icon: 'checklist' },
    { title: 'Calculadora de repasse', icon: 'calculator' },
  ];

  changeIndex(index: number) {
    this.abaSelecionada = index;
  }
}
